import { Server as socketServer, } from 'socket.io'

export default (serverObj, serverOptions, serverScript): void => {
  const io = new socketServer(serverObj, serverOptions)

  if (serverScript) serverScript(io)
}